import Vue from 'vue';
import moment from 'moment';

const dateFilter = Vue.filter('date', function (value) {
    const now = moment(new Date());
    let inputDate = moment(value);
    if (now.diff(inputDate, 'minutes') < 3) {
        return "just now"
    }

    return "at " + inputDate.format('DD-MM-yyyy HH:mm');
})

export default dateFilter;
